module.exports = __webpack_public_path__ + "js/3-67608e5f11885aba6d6c.chunk.worker.js"